import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import about_us_bg from 'src/assets/about_us_bg.jpg'

const AboutUs = () => {
  return (
    <Box>
      <Box
        sx={{
          height: { xs: 'fit-content', md: 'calc(100vh - 65px)' },
          maxHeight: '1000px',
          backgroundImage: `url(${about_us_bg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'overlay',
          backgroundColor: '#444444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          pb: { xs: 25, md: 'initial' },
        }}
      >
        <Box sx={{ height: '100%' }}>
          <Box
            sx={{
              width: {
                xs: '80%',
                sm: '90%',
                md: '700px',
                textAlign: 'center',
                color: '#f4f4f4',
              },
              pt: { xs: 22, md: 5 },
              mx: 'auto',
            }}
          >
            <Typography variant="h4" fontWeight={600} fontStyle="italic">
              Company Overview
            </Typography>
            <Typography variant="h6">Investment and funding</Typography>
          </Box>
          <Box
            sx={{
              px: 5,
              mt: { xs: 6, md: 5 },
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              flexDirection: 'column',
              color: '#f4f4f4',
            }}
          >
            <Typography
              sx={{ fontSize: '17px', maxWidth: { xs: '100%', md: '60%' } }}
            >
              Since 2016, respectively the time when we as the responsible
              persons of the company have been consolidated, we have started to
              invest continuously with all our individual resources both in the
              intellectual and material-financial aspect in the development of
              products, ie both software and hardware.
            </Typography>
            <Typography
              sx={{
                fontSize: '17px',
                maxWidth: { xs: '100%', md: '60%' },
                mt: 2.5,
              }}
            >
              In software development implies the modular development of the
              software system platform for iptv and the module for provisioning
              which for provisioning was requested and imposed on us as a
              separate part of the module to be developed due to the demand of
              telecommunication companies which depend on the technology of
              their implemented architecture.
            </Typography>
            <Typography
              variant="h5"
              fontWeight="500"
              sx={{ mt: 4, maxWidth: { xs: '100%', md: '60%' } }}
            >
              Long-term Partnership
            </Typography>
            <Typography
              sx={{
                fontSize: '17px',
                maxWidth: { xs: '100%', md: '60%' },
                mt: 2.5,
              }}
            >
              Our goal is to build a long-lasting partnership with our clients. Our company is committed to having a close relationship with our customers to provide top quality service and support ensuring total client satisfaction each and every day.
            </Typography>
            <Button
              variant="contained"
              sx={{ mt: 4, textTransform: 'none', color: '#fff' }}
            >
              <Link to="/softwares" style={{ color: 'inherit', textDecoration: 'none' }}>
                Learn More
              </Link>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AboutUs
